export default __webpack_public_path__ + "930664c9a53b680f68388f83cc89ecaa.png";